// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AdjustInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Manual signed adjustment request body — Full-gated.
 *
 * Required fields:
 *   franquia_id  (int)    — target franchise
 *   signed_micro (int)    — signed micro-credit delta (positive = credit, negative = debit, must != 0)
 *   reason       (string) — mandatory human-readable reason (must be non-empty)
 *   request_id   (string) — caller-supplied idempotency key
 *
 * Validation:
 *   - signed_micro == 0 is rejected
 *   - empty/whitespace reason is rejected
 */
import { registerContract } from './validate'

export interface AiCredits_AdjustInput {
franquia_id: number
signed_micro: number
reason: string
request_id: string
}

registerContract('AiCredits_AdjustInput', {
  franquia_id:  { type: 'number',  required: true },
  signed_micro: { type: 'number',  required: true },
  reason:       { type: 'string',  required: true },
  request_id:   { type: 'string',  required: true },
})
